const getAlertDialogProps = state => state.alertDialog;

export default getAlertDialogProps;
